/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_kr as kr,
  rec_n1 as n1,
} from "../../runtime/index.jsx";
export function AvanceIncidencia(e) {
  let t = (0, ReactCompiler.c)(10),
    { actual: n, onIr: r } = e,
    i = n + 1,
    a = `Paso ${n + 1} de ${n1.length}: ${n1[n]}`,
    o = `${(n * 100) / (n1.length - 1)}%`,
    s;
  t[0] === o
    ? (s = t[1])
    : ((s = (
        <div
          className={`absolute top-4 right-6 left-6 h-1 overflow-hidden rounded-full bg-(--border)`}
          aria-hidden={`true`}
          children={
            <div
              className={`h-full rounded-full bg-(--accent) transition-all duration-500 ease-(--curva)`}
              style={{
                width: o,
              }}
            />
          }
        />
      )),
      (t[0] = o),
      (t[1] = s));
  let c;
  t[2] !== n || t[3] !== r
    ? ((c = n1.map((e, t) => {
        let i = t < n;
        return (
          <button
            key={e}
            type={`button`}
            disabled={!i}
            onClick={() => r(t)}
            aria-label={i ? `Volver a ${e}` : e}
            className={`relative z-10 flex w-14 flex-col items-center gap-1 disabled:cursor-default`}
            children={[
              <span
                className={`flex h-9 w-9 items-center justify-center rounded-full border-2 text-xs font-semibold transition duration-300 ${i ? `animar-pop border-(--accent) bg-(--accent) text-(--accent-fg)` : t === n ? `animar-latido border-(--accent) bg-(--bg) text-(--accent-texto)` : `border-(--border) bg-(--bg) text-(--text)`}`}
                children={
                  i
                    ? (0, JSXRuntime.jsx)(kr, {
                        className: `h-4 w-4`,
                        strokeWidth: 3,
                      })
                    : t + 1
                }
              />,
              <span
                className={`text-[11px] ${t === n ? `font-semibold text-(--text-h)` : `text-(--text)`}`}
                children={e}
              />,
            ]}
          />
        );
      })),
      (t[2] = n),
      (t[3] = r),
      (t[4] = c))
    : (c = t[4]);
  let l;
  return (
    t[5] !== i || t[6] !== a || t[7] !== s || t[8] !== c
      ? ((l = (
          <div
            role={`progressbar`}
            aria-label={`Avance del reporte`}
            aria-valuemin={1}
            aria-valuemax={n1.length}
            aria-valuenow={i}
            aria-valuetext={a}
            className={`relative flex items-start justify-between`}
            children={[s, c]}
          />
        )),
        (t[5] = i),
        (t[6] = a),
        (t[7] = s),
        (t[8] = c),
        (t[9] = l))
      : (l = t[9]),
    l
  );
}
